import { useEffect, useMemo } from 'react';
import UniversalRecordTable from '../Tables/universalRecord/UniversalRecordTable';
import { useDocumentSequence } from '../../hooks/document/useDocumentSequence';
import { documentSequenceColumns } from '../../features/document/documentSequenceColumns';

const ActiveDocumentSequencesSection: React.FC = () => {
  const {
    activeList, 
    paginator,
    handlerGetActiveSequences,
  } = useDocumentSequence();

  const pageSize = paginator?.size || 10;

  const columns = useMemo(() => documentSequenceColumns, []);

  useEffect(() => {
    handlerGetActiveSequences(); // ✅ Trae los activos directamente
  }, []);

  return (
    <UniversalRecordTable
      columns={columns}
      data={activeList}
      paginator={paginator}
      showFilters
      onPageChange={() => {}} // opcional, si los activos no necesitan paginación
      onPageSizeChange={() => {}} // opcional
      pageSize={pageSize}
      noDataMessage="No hay series activas registradas."
      showPagination={false}        // 🚫 No mostrar paginación
      enableRowClick={false}       // 🚫 No permitir expansión
    />
  );
};

export default ActiveDocumentSequencesSection;
